import { useNavigate } from 'react-router';

import Button from '@cartwhl/ui/input/Button';

import {
  type AssetLibraryTypeFilter,
  getAssetLibraryPathWithTypeFilter,
} from '../AssetLibrary/assetLibraryFilters';

export default function SeeMoreInLibraryButton({
  typeFilter,
}: {
  typeFilter: Exclude<AssetLibraryTypeFilter, 'all'>;
}) {
  const navigate = useNavigate();

  return (
    <Button
      variant="tertiary"
      size="lg"
      className="border-primary bg-primary border"
      onClick={() => navigate(getAssetLibraryPathWithTypeFilter(typeFilter))}
    >
      See more in Library
    </Button>
  );
}
